module.exports = __webpack_public_path__ + "img/content_id_overview.6e50728d.svg";